import SignalTable from 'components/global/SignalTable/SignalTable';
import SimpleCard from 'components/global/SimpleCard';
import InvestorEditTeamModal from 'components/views/InvestorTeam/_components/InvestorTeamEditModal';
import InvestorTeamDeleteModal from 'components/views/InvestorTeam/_components/InvestorTeamDeleteModal';
import InvestorTeamRows from 'components/views/InvestorTeam/_components/InvestorTeamRows';
import { handleClickEditTeam } from 'components/views/InvestorTeam/_helpers/investorTeam.events';
import { fetchAndSetInvestorTeamData } from 'components/views/InvestorTeam/_helpers/investorTeam.resolvers';
import { $list, $view } from 'signals/global.signals';
import useEffectAsync from 'utils/useEffectAsync';

const InvestorTeams = () => {
  useEffectAsync(fetchAndSetInvestorTeamData);

  return (
    <SimpleCard>
      <SignalTable
        headers={[{
          key: 'name',
          value: 'Name',
        }, {
          key: 'userCount',
          value: 'Member Count',
        }, {
          key: 'Actions',
          value: 'Actions',
        }]}
        rows={InvestorTeamRows({ data: $list.value?.data || [] })}
        isLoading={$view.value.isTableLoading}
        onRowClick={(row) => handleClickEditTeam(row)}
      />
      <InvestorEditTeamModal />
      <InvestorTeamDeleteModal />
    </SimpleCard>
  );
};

export default InvestorTeams;
